import { render, staticRenderFns } from "./AccountInviteFriends.vue?vue&type=template&id=063a3c48&"
import script from "./AccountInviteFriends.vue?vue&type=script&lang=js&"
export * from "./AccountInviteFriends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports